import Section from "../../common/section";

const RelaseNotes = () => {
  return (
    <Section title="release_notes" className="edexlms-page-body release-notes">
      <div className="flex flex-column gap-4">
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.4.0 – Minor release</strong> - 28 July 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>
              Learning Objects Reports - Assessment % for Scorm Objects
            </li>
            <li style={{ margin: "8px 0" }}>
              Simplified Login Process Enabling Quick Access with Password or
              OTP
            </li>
            <li style={{ margin: "8px 0" }}>
              Forced Changed Password Flow now only triggers when a user signs
              in for the first time using a password
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.3.0 – Minor release</strong> - 14 June 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>Release Notes</li>
            <li style={{ margin: "8px 0" }}>
              Minor Fixes
              <ul>
                <li style={{ margin: "5px 0" }}>Login Page Message Display</li>
                <li style={{ margin: "5px 0" }}>
                  Learning Program Linear Progression
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.2.0 – Minor release</strong> - 23 May 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>
              User Export & Import formats aligned so the same file format can
              be used
            </li>
            <li style={{ margin: "8px 0" }}>
              Learning Plan assignments enhancements:
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Time zone support added to Learning Plan assignments
                </li>
                <li style={{ margin: "5px 0" }}>
                  Assignment & reminder emails now account for the assignment
                  time zone
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.1.0 – Minor release</strong> - 01 May 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>
              Multi-lingual support for notifications
            </li>
            <li style={{ margin: "8px 0" }}>Cohort users view and export</li>
            <li style={{ margin: "8px 0" }}>
              Preferred language selection for Enterprise & user-level
            </li>
            <li style={{ margin: "8px 0" }}>
              Notifications in selected languages (6 pre-specified)
            </li>
            <li style={{ margin: "8px 0" }}>
              Reports enhancements
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Displaying status of optional objects
                </li>
                <li style={{ margin: "5px 0" }}>
                  Ability to see reports for inactive users
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.0.0 – Major release</strong> - 03 March 2025
          </div>
          <div style={{ margin: "10px 0" }}>
            System released with core funtionality: 
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>User administration</li>
            <li style={{ margin: "8px 0" }}>User profile custom fields</li>
            <li style={{ margin: "8px 0" }}>Role management</li>
            <li style={{ margin: "8px 0" }}>Learning management</li>
            <li style={{ margin: "8px 0" }}>Learning assignment</li>
            <li style={{ margin: "8px 0" }}>Dynamic cohorts</li>
            <li style={{ margin: "8px 0" }}>Notifications (specified)</li>
            <li style={{ margin: "8px 0" }}>Reports (specified)</li>
            <li style={{ margin: "8px 0" }}>
              Enterprise management
              <ul>
                <li style={{ margin: "5px 0" }}>Theming</li>
                <li style={{ margin: "5px 0" }}>SMTP</li>
                <li style={{ margin: "5px 0" }}>Email templates</li>
                <li style={{ margin: "5px 0" }}>Learning dashboards</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </Section>
  );
};

export default RelaseNotes;
